import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "label", "labelClassName", "hideLabel", "selectClassName", "field", "setFilter", "filters", "options", "selectAttrs"];
import React from 'react';
import classNames from 'classnames';
import { withSearch } from '@elastic/react-search-ui';
import deepEqual from 'deep-equal';
import { findFacetValueInFilters } from '../helpers';
import SelectBox from '../../Forms/SelectBox';
var blockClass = 'search-filter';

var SingleSelectFacet = function SingleSelectFacet(_ref) {
  var className = _ref.className,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      hideLabel = _ref.hideLabel,
      selectClassName = _ref.selectClassName,
      field = _ref.field,
      setFilter = _ref.setFilter,
      filters = _ref.filters,
      options = _ref.options,
      selectAttrs = _ref.selectAttrs,
      attrs = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = classNames(blockClass, blockClass + "--single-select", className);
  var labelClasses = classNames(blockClass + "__title", labelClassName || 'h5 mb-0');
  var selectClasses = classNames(blockClass + "__select", selectClassName);
  var selectedValues = findFacetValueInFilters(field, filters, 'all') || [];
  var value = selectedValues[0];
  var selected = !value ? options[0] : options.filter(function (option) {
    return deepEqual(option.value, value);
  })[0];
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, attrs), !hideLabel && /*#__PURE__*/React.createElement("div", {
    className: labelClasses
  }, label), /*#__PURE__*/React.createElement(SelectBox, _extends({
    className: selectClasses,
    defaultValue: options[0],
    value: selected,
    options: options,
    onChange: function onChange(option) {
      return setFilter(field, option.value);
    }
  }, selectAttrs)));
};

export var SingleSelectFacetComponent = SingleSelectFacet;
export default withSearch(function (_ref2) {
  var setFilter = _ref2.setFilter,
      filters = _ref2.filters;
  return {
    setFilter: setFilter,
    filters: filters
  };
})(SingleSelectFacet);